// import Swiper JS
import Swiper, { Navigation, Autoplay } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';


function initSwiper_reviews(){
  // configure Swiper to use modules
  Swiper.use([Navigation, Autoplay]);

  var cardSlider = new Swiper('.reviews_slider', {
    slidesPerView: 1,
    spaceBetween: 80,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1220: {
        slidesPerView: 3,
      }
    }
  });
}

jQuery(document).ready(function() {
  setTimeout(function(){
      initSwiper_reviews();
  }, 100);
});